import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import ReactCodeInput from 'react-verification-code-input';
import playstore from '../../image/android-store.png'
import applestore from '../../image/apple-store.png'
import Snackbars from '../pages/Snackbars';
import validator from 'validator';
import { useTranslation } from "react-i18next";
import axios from 'axios';

function RegisterGoogleAuthDemo(props) {
    const { t } = useTranslation();
    const history = useHistory();

    const [gurl, setGurl] = useState('');
    const [gcode, setGcode] = useState("");
    const [codeinput, setCodeinput] = useState('');
    const [codeinput_error, setcodeinputError] = useState('');
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error_msg, setErrorMsg] = useState("");
    const [success_msg, setSuccessMsg] = useState("");
    const [logo, setLogo] = useState("");

    useEffect(() => {
        if (window.sessionStorage.getItem("register_user_id") === null || window.sessionStorage.getItem("register_user_id") === undefined || window.sessionStorage.getItem("register_user_id") === "" || window.sessionStorage.getItem("register_user_id") === "null") {
            history.push('/demorequest');
        }
        handleLoad();
        handlelogo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history]);

    const handlelogo = () => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
        }
        axios.get(process.env.REACT_APP_API_URL + 'getalllogo', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    console.log(process.env.REACT_APP_FILE_PATH_LOGO + res.data.whitelogo);
                    setLogo(process.env.REACT_APP_FILE_PATH_LOGO + res.data.whitelogo);
                }

            })
            .catch(function (error) {

            });
    }

    const handleLoad = () => {
        var jsonpar = JSON.stringify({
            'register_user_id': window.sessionStorage.getItem("register_user_id"),
        });
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
        }

        axios.post(process.env.REACT_APP_API_URL + 'getGoogleAuthDetails', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setGurl(res.data.gurl);
                    setGcode(res.data.auth_code);
                } else {
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                }
            })
            .catch(function (error) {
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    const validatecode = (value) => {
        setCodeinput(value);
        if (!validator.isEmpty(value)) {
            setcodeinputError("");
            return true;
        } else {
            setcodeinputError(t('ERROR_MSG.VALID_AUTHCODE'));
            return false;
        }
    }


    const handlesubmit = () => {
        if (validatecode(codeinput) === false) {
            setcodeinputError(t('ERROR_MSG.VALID_AUTHCODE'));
            return false;
        } else {
            setcodeinputError("");
            document.getElementById("submit").disabled = true;
            document.getElementById("submit").textContent = t('PROCESSING');
            var jsonpar = JSON.stringify({
                'auth_code': codeinput,
                'register_user_id': window.sessionStorage.getItem("register_user_id"),
            });
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            }

            axios.post(process.env.REACT_APP_API_URL + 'verifyauthcodewithsession', jsonpar, { headers: headers })
                .then(function (res) {
                    res = res.data;
                    if (res.code === "200") {
                        setSuccess(true);
                        setSuccessMsg(t('ERROR_MSG.REGISTER_COMPLETE'));
                        setTimeout(() => {
                            setSuccess(false);
                            window.sessionStorage.setItem("user_id", res.data.id);
                            window.sessionStorage.setItem("user_jwt", res.data.jwt_token);
                            window.sessionStorage.setItem("user_ip", res.data.ipaddress);
                            window.sessionStorage.setItem("diffips", res.data.otpdata.diffips);
                            window.sessionStorage.setItem("autologout", res.data.otpdata.autologout);
                            window.sessionStorage.setItem("aftermsg", res.data.otpdata.aftermessage);
                            window.sessionStorage.setItem("message", res.data.otpdata.message);
                            window.sessionStorage.setItem("autologouttime", parseInt(res.data.otpdata.autologouttime));
                            window.sessionStorage.setItem("paddingtime", parseInt(res.data.otpdata.padding));
                            window.location.href = process.env.REACT_APP_SITE_URL + "dashboard";
                        }, 1000);

                    } else {
                        document.getElementById("submit").disabled = false;
                        document.getElementById("submit").textContent = t('BUTTONS.SUBMIT');
                        setError(true);
                        setErrorMsg(res.message);
                        setTimeout(() => {
                            setError(false);
                        }, 6000);
                    }
                })
                .catch(function (error) {
                    document.getElementById("submit").disabled = false;
                    document.getElementById("submit").textContent = t('BUTTONS.SUBMIT');
                    setError(true);
                    setErrorMsg(t('ERROR_MSG.SOMETHING'));
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                });
        }
    }

    return (
        <div className="vh-100 login-main-page p-0">
            {error ? <Snackbars open_close={error} type="error" message={error_msg} /> : ""}
            {success ? <Snackbars open_close={success} type="success" message={success_msg} /> : ""}
            <div className="row m-0 justify-content-center h-100 align-items-center">
                <div className="login-wrapper p-4">
                    <div className="login-aside-right">
                        <div className="col-xl-12">
                            <div className="authincation-content">
                                <div className="row no-gutters">
                                    <div className="col-xl-12">
                                        <div className="auth-form-1">
                                            <div className="mb-4">
                                                <Link to="#" className="login-logo1 logo-center">
                                                    <img src={logo} alt="" className='mb-4 logo' />
                                                </Link>
                                                <h4 className="text-white mb-1 text-center">{t('LABEL.GOOGLE_AUTHENTICATOR_TITLE')}</h4>
                                            </div>

                                            <div className='qr-scan'>
                                                <img src={gurl} alt="" className='mb-4 qr-code' />
                                            </div>
                                            <div className='form-group text-center text-input-box'>
                                                <label className='mb-1 text-white'> <strong>{t('LABEL.GOOGLE_AUTHENTICATOR_TITLE')}</strong> </label>
                                                <ReactCodeInput type="number" fields={6} onChange={validatecode} value={codeinput} />
                                                {codeinput_error !== "" ? <label className='text-red'>{codeinput_error}</label> : ""}
                                            </div>
                                            <div className='fullWidth'>
                                                <div className='text-center center-box'>
                                                    <button type="button" id="submit" onClick={handlesubmit} className="btn btn-login-hover bg-white text-primary btn-block width-auto float-left">{t('BUTTONS.SUBMIT')}</button>
                                                    <Link className="text-white color-bg-link width-auto cancel-btn" to='/login'>{t('BUTTONS.CANCEL')} </Link>
                                                </div>
                                            </div>
                                            <div className='fullWidth'>
                                                <p className="text-white text-center mt-5">{t('GAUTH_TEXT_TWO')}</p>
                                            </div>
                                            <div className='fullWidth'>
                                                <div className='center-box download-link'>
                                                    <a rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_IN&gl=US&pli=1" target="_blank"><img src={playstore} alt="" className='mb-4 qr-code' /></a>
                                                    <a rel="noreferrer" href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank"><img src={applestore} alt="" className='mb-4 qr-code' /></a>
                                                </div>
                                            </div>
                                            <div className='fullWidth'>
                                                <p className="text-white text-center">{t('GAUTH_TEXT_TWO')}</p>
                                            </div>
                                            <div className='fullWidth'>
                                                <div className="Security text-white center-security"> <span>{t('LABEL.SECURITY_KEY')}</span>
                                                    <h2 className="text-white">{gcode}</h2>
                                                </div>
                                            </div>


                                            <div className='new-account mt-5'>
                                                <p className='text-white text-center'> {t('ALREADY_ACCOUNT')} <Link className="text-white color-bg-link" to='/demologin'>  {t('LINK.RETURN_LOGIN')} </Link> </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default RegisterGoogleAuthDemo;
